import { api } from '../../lib/api'

export interface GstState {
  enabled: boolean
  /** The business has answered "registered under GST?" at least once. */
  decided: boolean
  plan_allows: boolean
  has_gstin: boolean
  non_gst_title: string
  titles: string[]
}

export const gstKey = ['settings', 'gst'] as const

export const fetchGst = () => api.get<{ data: GstState }>('/settings/gst').then((r) => r.data.data)

export const saveGst = (body: { enabled: boolean; non_gst_title?: string }) =>
  api.put<{ data: GstState }>('/settings/gst', body).then((r) => r.data.data)
